import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";
import { isEmpty } from "lodash";

async function create(data) {
  const response = await http.postData("/pengkajian-akhir-hayat", data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function update(id, data) {
  const response = await http.putData(`/pengkajian-akhir-hayat/${id}`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function getByRegister(register_id: string | number) {
  const response = await http.getData(`/register/${register_id}/pengkajian-akhir-hayat`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function find(id: number) {
  const response = await http.getData(`/pengkajian-akhir-hayat/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function signPengkaji(id: number, data) {
  return http.putData(`/pengkajian-akhir-hayat/${id}/sign-pengkaji`, data);
}

async function ttdStatus() {
  return http.getData(`/users/ttd-status`);
}

async function markKeluarga(id: number, data) {
  const response = await http.putData(`/pengkajian-akhir-hayat/${id}/mark-keluarga`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function destroy(id: number) {
  const response = await http.deleteData(`/pengkajian-akhir-hayat/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  const data = isEmpty(response?.data) ? null : response.data;
  return data;
}

function print(id) {
  window.open(`${http.getAPI()}/pengkajian-akhir-hayat/${id}/pdf`, "_blank");
}

export default {
  create,
  update,
  getByRegister,
  find,
  signPengkaji,
  ttdStatus,
  markKeluarga,
  destroy,
  print
};
